// engine-exception: workload is a technicians × weeks aggregate over /v1/workload (no resource, no meta), so no ScreenDef kind renders it
import { PageHeader } from '../../engine/design/primitives/Misc';
import { WorkloadGrid } from './WorkloadGrid';

export function WorkloadScreen() {
  return (
    <div className="hf-page">
      <PageHeader title="Workload" eyebrow="projects" subtitle="Who is booked when: allocated minutes of open project tasks against each technician's weekly capacity." />
      <WorkloadGrid />
    </div>
  );
}
